// import LedBulbImg from "../assets/products/3.png";
// import DownlightImg from "../assets/products/9.png";
// import PanelImg from "../assets/products/28.png";
// import FloodImg from "../assets/products/31.png";
// import RopeImg from "../assets/products/35.png";

// /* ================= LOCAL IMAGE FALLBACK MAP =================
//    Firebase-stored product/category image URLs can go stale/404.
//    Instead of trusting them, pick a local asset by matching the
//    item's category/name/title against known keywords. */
// const CATEGORY_IMAGE_MAP = [
//   { keywords: ["bulb", "candle"], image: LedBulbImg },
//   { keywords: ["downlight", "down light", "cob", "smd", "ice light"], image: DownlightImg },
//   { keywords: ["batten", "tube"], image: DownlightImg },
//   { keywords: ["panel"], image: PanelImg },
//   { keywords: ["flood", "street"], image: FloodImg },
//   { keywords: ["rope", "strip", "decorative"], image: RopeImg },
// ];

// export const DEFAULT_PRODUCT_IMAGE = LedBulbImg;

// /**
//  * Resolve a local image for a product or category, ignoring any
//  * Firebase-stored image/images/imageUrl field. Matches on whichever
//  * of these text fields the item has.
//  */
// export function getProductImage(item) {
//   if (!item) return DEFAULT_PRODUCT_IMAGE;

//   const haystack = [
//     item.category,
//     item.subcategory,
//     item.name,
//     item.title,
//     item.sub,
//     item.product,
//   ]
//     .filter(Boolean)
//     .join(" ")
//     .toLowerCase();

//   const match = CATEGORY_IMAGE_MAP.find(({ keywords }) =>
//     keywords.some((kw) => haystack.includes(kw))
//   );

//   return match ? match.image : DEFAULT_PRODUCT_IMAGE;
// }

// export default getProductImage;


import LedBulbImg from "../assets/products/3.png";
import DownlightImg from "../assets/products/9.png";
import PanelImg from "../assets/products/28.png";
import FloodImg from "../assets/products/31.png";
import RopeImg from "../assets/products/35.png";
import { getImageUrl } from "../config/apiConfig";

/* ================= LOCAL IMAGE FALLBACK MAP =================
   Used ONLY when a product/category has no real uploaded image.
   Picks a local asset by matching the item's category/name/title
   against known keywords. Mirrors src/utils/getProductImage.js
   in the frontend project — keep both files in sync. */
const CATEGORY_IMAGE_MAP = [
  { keywords: ["bulb", "candle"], image: LedBulbImg },
  { keywords: ["downlight", "down light", "cob", "smd", "ice light"], image: DownlightImg },
  { keywords: ["batten", "tube"], image: DownlightImg },
  { keywords: ["panel"], image: PanelImg },
  { keywords: ["flood", "street"], image: FloodImg },
  { keywords: ["rope", "strip", "decorative"], image: RopeImg },
];

export const DEFAULT_PRODUCT_IMAGE = LedBulbImg;

/**
 * The "does this item actually have a real uploaded image" check, shared
 * by every place in the app that needs to decide between a real
 * Admin-Panel image and a local placeholder (getCutoutImage.js,
 * TopSellingProducts.js, ShopScreen.jsx, HlcCalculator.js, OfferSection.js).
 * Returns a resolved absolute URL, or null if there's no real image —
 * never a local placeholder itself, so callers can tell the two apart.
 */
export function getRealImageUrl(item) {
  if (!item) return null;
  const realUrl = extractFirstImageUrl(item.images);
  if (realUrl) return getImageUrl(realUrl);
  if (typeof item.image === "string" && item.image.trim()) return getImageUrl(item.image);
  if (typeof item.imageUrl === "string" && item.imageUrl.trim()) return getImageUrl(item.imageUrl);
  return null;
}

/**
 * Resolve the image to show for a product or category.
 *
 * Priority:
 *  1. Real uploaded image URL (via getRealImageUrl — item.images / item.image / item.imageUrl)
 *  2. Local keyword-based fallback (category/name matching)
 *  3. DEFAULT_PRODUCT_IMAGE (white bulb)
 */
export function getProductImage(item) {
  if (!item) return DEFAULT_PRODUCT_IMAGE;

  // 1. Prefer a real uploaded image URL (resolve relative paths against
  //    the backend origin — adminhlc-api returns paths, not full URLs)
  const realUrl = getRealImageUrl(item);
  if (realUrl) return realUrl;

  // 2. Fall back to keyword matching on text fields
  const haystack = [
    item.category,
    item.subcategory,
    item.name,
    item.title,
    item.sub,
    item.product,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const match = CATEGORY_IMAGE_MAP.find(({ keywords }) =>
    keywords.some((kw) => haystack.includes(kw))
  );

  // 4. Last resort
  return match ? match.image : DEFAULT_PRODUCT_IMAGE;
}

/**
 * item.images can look like:
 *   { "13W Cool White": ["https://.../a.jpg", "https://.../b.jpg"] }
 *   { "general": "https://.../a.jpg" }
 *   { "0": "https://.../a.jpg" }
 * Returns the first usable URL found, or null.
 */
function extractFirstImageUrl(images) {
  if (!images || typeof images !== "object") return null;

  for (const key of Object.keys(images)) {
    const val = images[key];
    if (Array.isArray(val)) {
      const first = val.find((v) => typeof v === "string" && v.trim());
      if (first) return first;
    } else if (typeof val === "string" && val.trim()) {
      return val;
    }
  }
  return null;
}

export default getProductImage;